import type { FC } from 'react';

interface Props {
  className?: string;
}

const FencedYardIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 8v8M8 6v10M12 8v8M16 6v10M20 8v8M4 16h16M4 8h16"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 20h20" />
      <circle cx="12" cy="3" r="1" fill="currentColor" />
    </svg>
  );
};

export default FencedYardIcon;
